import '@/sections/about-constructor/about-constructor-slider';
import '@/sections/first-screen';
import '@/sections/cards';
import '@/sections/contacts';
import '@/sections/gallery';
import '@/sections/promotions-list';
import '@/sections/infrastructure';
import '@/components/cards-grid';
import '@/components/favorite-state';
import '@/components/flat';
import '@/sections/ways-to-buy';
import '@/components/similar';
import '@/components/up-button';

import {
    initCircleSlider,
    initConstructorWidget,
    initCustomSelect,
    initDesignSlider,
    initDetailsAccordion,
    initExtraTabs,
    initFavorite,
    initFavoritesList,
    initFavoriteState,
    initForm,
    initFullScreenSlider,
    initHashTabs,
    initInfrastructure,
    initMenu,
    initMenuTrigger,
    initMortgageCalculator,
    initOffersList,
    initParallax,
    initParametric,
    initPlanoplan,
    initPopup,
    initPreloader,
    initSwiperSlider,
    initTabs,
    initToggle,
    initVideoOnScroll,
    initWhiteBox,
    // launchConstrWidget,
    lazyLoadElements
} from './common';
import CookiesNotice from '@/components/cookies-notice';
import {FinishingPopup} from '@/components/popup/popup';
import Observer from './observer';
import ScrollBy from '@/components/scrollBy';
// import {SearcherPopup} from '../../components/popup/popup';
import {Utils} from '@/common/scripts/utils';
import Validation from '@/components/form/validation';

const validation = new Validation();
const observer = new Observer();

/* Ленивая загрузка */
const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

// Бургер
const menuTriggerElements = [...document.querySelectorAll('.j-menu-trigger')];

if (menuTriggerElements.length) {
    initMenuTrigger(menuTriggerElements);
}

// Меню
const menuElement = document.querySelector('.j-menu');

if (menuElement) {
    initMenu(menuElement);
}

// Вложенные табы
const checkNestedTabs = (wrapper) => {
    const container = wrapper ? wrapper : document;

    // Табы верхнего уровня
    const tabsParent = Array.from(container.querySelectorAll('.j-tabs-parent'));

    tabsParent.forEach((elem) => {
        initExtraTabs({
            elem,
            hash          : Boolean(elem.dataset?.hash),
            contentsParent: '.j-tabs-parent__content',
            contentItem   : '.j-tabs-parent-content__item'
        });
    });

    // Табы второго уровня
    const tabsSecondLevel = Array.from(container.querySelectorAll('.j-tabs-second-level'));

    tabsSecondLevel.forEach((elem) => {
        initExtraTabs({
            elem,
            contentsParent: '.j-tabs-second-level__content',
            contentItem   : '.j-tabs-second-level-content__item'
        });
    });
};

const checkTabs = (wrapper) => {
    const container = wrapper ? wrapper : document;

    // Табы
    const tabs = Array.from(container.querySelectorAll('.j-tabs-wrap:not([data-hash="true"])'));

    tabs.forEach((elem) => {
        initTabs(elem);
    });
};

checkNestedTabs();
checkTabs();

const hashTabs = Array.from(document.querySelectorAll('.j-tabs-wrap[data-hash="true"]'));

hashTabs.forEach((elem) => {
    initHashTabs(elem);
});

// Селект без группировок и мультивыбора
const selectSelectors = Array.from(document.querySelectorAll('.j-custom-select_single_select'));

if (selectSelectors.length) {
    selectSelectors.forEach((selectItem) => {
        initCustomSelect(selectItem);
    });
}

// Подключение параметрического
const parametricElement = document.querySelector('.j-parametric');

if (parametricElement) {
    initParametric({
        element: parametricElement
    });
}

// Дефолтные туглеры
const toggleElements = Array.from(document.querySelectorAll('.j-toggle-wrapper'));

toggleElements.forEach((toggle) => {
    initToggle(toggle);
});

// Ипотечный калькулятор
const mortgageCalculator = document.querySelector('.j-mortgage-calculator');

if (mortgageCalculator) {
    initMortgageCalculator(mortgageCalculator);
}

// Слайдер на главной
const fullScreenSliderWrapper = document.querySelector('.j-full-screen-slider');

if (fullScreenSliderWrapper) {
    initFullScreenSlider(fullScreenSliderWrapper);
}

const homeNoSliderCircleSliders = [...document.querySelectorAll('.j-home-no-slider .j-circle-slider')];

homeNoSliderCircleSliders.forEach((circleWrapper) => {
    return initCircleSlider(circleWrapper);
});

// Прелоадер на главной (обязательно после слайдера)
const preloads = [...document.querySelectorAll('.j-preloader')];

preloads.forEach((preloader) => {
    initPreloader(preloader);
});

// Запускает проигрывание видео, когда до него доскроллили
const videosOnScroll = [...document.querySelectorAll('.j-scroll-video')];

if (videosOnScroll.length) {
    videosOnScroll.forEach((item) => {
        initVideoOnScroll(item);
    });
}

// Попапы через фасад
initPopup({
    removeDelay: 400
});

// Формы
const formWrappers = Array.from(document.querySelectorAll('.j-form'));

if (formWrappers.length) {
    formWrappers.forEach((wrapper) => {
        initForm(wrapper);
    });
}

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));
const isDesktop = !Utils.isMobile();

if (anchors.length) {
    const scrollBy = new ScrollBy();
    const headerWrap = document.querySelector('.j-header');

    scrollBy.init({
        takeElements: [headerWrap],
        offset      : isDesktop ? -110 : -70,
        anchors
    });
}

const lazyLoadInit = () => {
    const lazyElementsPopup = Array.from(document.querySelectorAll('.j-popup__content [loading=lazy]'));

    if (lazyElementsPopup.length) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                lazyLoadElements(lazyElementsPopup);
            });
        } else {
            lazyLoadElements(lazyElementsPopup);
        }
    }
};

// Подписка на открытие попапов
observer.subscribe('popup:open', (popup) => {
    if (!popup.content) {
        return;
    }

    // Форма
    const form = popup.content.querySelector('.j-form');
    const selects = Array.from(popup.content.querySelectorAll('.j-custom-select'));
    const sliders = Array.from(popup.content.querySelectorAll('.j-swiper-slider'));

    if (form) {
        validation.refresh(form);

        initForm(form, popup);
    }

    if (selects.length) {
        selects.forEach((select) => {
            initCustomSelect(select);
        });
    }

    if (sliders.length) {
        let activeSlide = 0;

        if (popup.currentTarget) {
            activeSlide = popup.currentTarget.dataset.slide || 0;
        }

        sliders.forEach((wrapper) => {
            initSwiperSlider({
                wrapper,
                activeSlide
            });
        });
    }

    checkNestedTabs(popup.content);
    checkTabs(popup.content);

    initPopup();

    /* Ленивая загрузка в попапах */
    lazyLoadInit();
});

// Кастомный слайдер swiper slider
const slidersCustom = Array.from(document.querySelectorAll('.j-swiper-slider'));

slidersCustom.forEach((wrapper) => {
    initSwiperSlider({wrapper});
});

const flatSliders = [...document.querySelectorAll('.j-home-no-slider .j-design-slider')];

if (flatSliders.length) {
    flatSliders.forEach((flatSlider) => {
        initDesignSlider(flatSlider);
    });
}

// Кнопки избранного
const favoriteButtons = Array.from(document.querySelectorAll('.j-favorite:not([data-init])'));

if (favoriteButtons.length) {
    initFavorite(favoriteButtons);
}

// Раздел избранного
const favoritesList = document.querySelector('.j-favorite-list');

if (favoritesList) {
    initFavoritesList(favoritesList);
}

// Избранное в шапке сайта
const favoriteState = document.querySelector('.j-favorite-state');

if (favoriteState) {
    initFavoriteState(favoriteState);
}

// Параллакс по мышке
const parallaxSections = [...document.querySelectorAll('.j-parallax')];

if (parallaxSections.length) {
    parallaxSections.forEach((parallaxSection) => {
        initParallax(parallaxSection);
    });
}

// Акции и новости
const offersList = document.querySelector('.j-offers');

if (offersList) {
    initOffersList(offersList);
}

const detailsArr = [...document.querySelectorAll('.j-details')];

if (detailsArr.length) {
    detailsArr.forEach((details) => {
        initDetailsAccordion(details);
    });
}

const planoplanWidgets = [...document.querySelectorAll('.j-flat__planoplan-widget')];

if (planoplanWidgets.length) {
    planoplanWidgets.forEach((widget) => {
        initPlanoplan({elem: widget});
    });
}

const infrastructurePage = document.querySelector('.j-infrastructure');

if (infrastructurePage) {
    initInfrastructure();
}

// Инфо-попап при заходе в отделку
const finishingInfoPopup = document.querySelector('.j-popup__finishing-info');

if (finishingInfoPopup) {
    const infoPopup = new FinishingPopup();

    infoPopup.init();
}

// При открытии карточки квартиры отправляет события в GA
// view_item - старое событие, select_item - новое событие
const flatTitle = document.querySelector('.j-flat-title') ?
    document.querySelector('.j-flat-title').textContent :
    '';

if (flatTitle && window.gtag) {
    const flatSquare = document.querySelector('.j-flat-area').innerHTML;
    const flatPrice = document.querySelector('.j-flat-main-price') ?
        document.querySelector('.j-flat-main-price').textContent :
        0;
    const flatTagsArray = Array.from(document.querySelectorAll('.j-flat-detail'));
    const flatTags = flatTagsArray.length ?
        flatTagsArray.map((item) => {
            return item.innerHTML;
        }) :
        [];
    const constructor = document.querySelector('.flat__constructor');

    if (constructor) {
        flatTags.push('Конструктор планировок');
    }

    try {
        window.gtag('event', 'view_item', {
            // eslint-disable-next-line
            send_to: "G-LLQN03TWXX",
            rooms  : flatTitle,
            square : flatSquare,
            price  : flatPrice,
            tags   : flatTags
        });

        // eslint-disable-next-line
        console.log("view_item", flatTitle, flatSquare, flatPrice);
    } catch (error) {
        console.error(error);
    }
}

// Отправляет события в GA при клике на баннера в параметрическом
const parametricBanners = [...document.querySelectorAll('.j-parametric-banner')];

if (parametricBanners.length && window.gtag) {
    parametricBanners.forEach((banner) => {
        const bannerType = 'banner';

        banner.addEventListener('click', () => {
            try {
                window.gtag('event', 'go_constructor', {
                    // eslint-disable-next-line
                    send_to: "G-LLQN03TWXX",
                    place  : bannerType
                });

                // eslint-disable-next-line
                console.log("go_constructor", bannerType);
            } catch (error) {
                console.error(error);
            }
        });
    });
}

const whiteBoxWrappers = [...document.querySelectorAll('.j-white-box__including')];

whiteBoxWrappers.forEach((whiteBoxWrapper) => {
    initWhiteBox({wrapper: whiteBoxWrapper});
});

// Уведомление об использовании кук
const cookiesWrapper = document.querySelector('.j-cookies-notice');

if (cookiesWrapper) {
    const cookies = new CookiesNotice();

    cookies.init(cookiesWrapper);
}

const appHeight = () => {
    const doc = document.documentElement;

    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

window.addEventListener('resize', appHeight);

appHeight();


const widgetButtons = Array.from(document.querySelectorAll('.j-constructor-widget'));


let widgetToken = '';

if (window.location.href.includes('test')) {
    widgetToken = '79563efd-287a-40a4-8a89-f3be267b1353';
} else if (window.location.host.includes('house')) {
    widgetToken = '98aac6ad-e41d-4d41-91a4-792b244d45a4';
} else {
    widgetToken = 'b6672dcc-fee6-44d9-abcc-d71debcde6bd';
}

widgetButtons.forEach((widgetButton) => {
    initConstructorWidget({
        element: widgetButton,
        token  : widgetToken
    });
});

// Проверка куки и отображение элемента, если куки не существует
const cookieName = 'tooltipClosed';
const superTooltip = document.querySelector('.j-parametric-filter-demo');

const closeTooltipHandler = (elements) => {
    const cookieTime = 24 * 60 * 60 * 1000 * 5;
    const expiresDate = new Date(Date.now() + cookieTime);

    Utils.setCookie(cookieName, 'true', {
        expires : expiresDate.toUTCString(),
        SameSite: 'None',
        Secure  : true
    });
    elements.forEach((element) => {
        element.classList.add('hide');
        element.removeEventListener('click', closeTooltipHandler);
        document.body.classList.add('demo-tooltip-transition');
    });
    setTimeout(() => {
        document.body.classList.remove('demo-tooltip-open');
        document.body.classList.remove('demo-tooltip-transition');
    }, 500);
};
const showDemoTooltip = () => {
    document.body.classList.add('demo-tooltip-open');
    const tooltipClose = document.querySelectorAll('.j-parametric-filter-demo-close');

    tooltipClose.forEach((element) => {
        element.addEventListener('click', () => {
            return closeTooltipHandler(tooltipClose);
        });
    });
};


if (!Utils.getCookie(cookieName) && superTooltip) {
    showDemoTooltip();
}

const flatNote = document.querySelector('.j-flat-note');

if (flatNote) {
    const flatWrapper = document.querySelector('.j-flat');

    window.addEventListener('scroll', () => {
        if (window.scrollY > flatWrapper.offsetTop + flatWrapper.offsetHeight - 100) {
            flatNote.classList.add('is-show');
        } else {
            flatNote.classList.remove('is-show');
        }
    });
}

const setVH = () => {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;

    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
    // We execute the same script as before
        vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setVH();
    });
} else {
    setVH();
}
